/**
 * KaraokeText — lazy "spoken word" highlighter.
 *
 * Receives the FULL utterance text + the current `[start, end]` char
 * range from useSpeechNarration. Renders the text as three spans —
 * already-spoken (dimmed), current word (highlighted with the brand
 * mint), upcoming (default colour). Pure CSS transitions; no DOM
 * mutation per word, no React re-render storm.
 *
 * Performance: even on a 2,500-word whitepaper part, this is one
 * setState per word boundary (~150-200 events for a 5-min read),
 * which is well below the 60fps threshold.
 */
export default function KaraokeText({ text, range, className = "", testid = "karaoke" }) {
  if (!text) return null;
  if (!range) {
    return (
      <p className={className} data-testid={`${testid}-idle`}>
        {text}
      </p>
    );
  }
  const [start, end] = range;
  const before = text.slice(0, start);
  const word = text.slice(start, end);
  const after = text.slice(end);
  return (
    <p className={className} data-testid={`${testid}-active`}>
      <span className="text-white/40">{before}</span>
      <span
        className="text-[#00FF9D] bg-[#00FF9D]/10 rounded-sm px-0.5 transition-colors"
        data-testid={`${testid}-current-word`}
      >
        {word}
      </span>
      <span className="text-white/85">{after}</span>
    </p>
  );
}
